"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrumPage = exports.AI_NOTES_SEPARATOR = exports.MAX_CONNECT_DURATION_MS = exports.DATADOG_TRACE_TAGS_HEADER = exports.DATADOG_TRACE_SAMPLING_PRIORITY_HEADER = exports.DATADOG_TRACE_ORIGIN_HEADER = exports.DATADOG_TRACE_PARENT_HEADER = exports.DATADOG_TRACE_HEADER = exports.TABLE_COLUMN_LIMIT = exports.TABLE_NON_DEFAULT_COLUMN_LIMIT = exports.TABLE_DEFAULT_COLUMN_NAMES = exports.CALLBACK_RECEIVED_COLUMN_NAME = exports.CustomHTTPHeader = exports.REFER_A_FRIEND_URL = exports.ARRAY_DELIMITER = exports.zServiceAccountKey = exports.zRemoteEnv = exports.zEnv = exports.Env = exports.AssertionError = exports.ACCEPT_CALLBACKS_WITHIN_DAYS = exports.CALLBACK_REGEX = exports.SAMPLE_RATE = void 0;
exports.typeCheck = typeCheck;
exports.assertType = assertType;
exports.assertUniqueKeysAndValues = assertUniqueKeysAndValues;
const zod_1 = require("zod");
const time_1 = require("./time");
// Audio codec sample rate in Hz.
exports.SAMPLE_RATE = 16_000;
// Format of the SIP "To:" field for callbacks. If you modify this, make sure to
// change siphon's inbound.xml accordingly.
exports.CALLBACK_REGEX = /^callback_to_(user|pooled_telephone)_id_(\d+)$/;
/**
 * The maximum number of days within which we will accept inbound callbacks to
 * Orum-provisioned numbers.
 */
exports.ACCEPT_CALLBACKS_WITHIN_DAYS = 30;
/**
 * Indicates an Orum type/value assertion was violated.
 */
class AssertionError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.AssertionError = AssertionError;
function typeCheck(_input) {
    return true;
}
function assertType(typeGuard, data, message) {
    if (!typeGuard(data)) {
        throw new AssertionError(message);
    }
}
var Env;
(function (Env) {
    Env["TEST"] = "test";
    Env["DEV"] = "development";
    Env["PLAYGROUND"] = "playground";
    Env["STAGING"] = "staging";
    Env["PROD"] = "production";
})(Env || (exports.Env = Env = {}));
exports.zEnv = zod_1.z.enum(Env);
exports.zRemoteEnv = zod_1.z.enum([Env.PLAYGROUND, Env.STAGING, Env.PROD]);
exports.zServiceAccountKey = zod_1.z.object({
    type: zod_1.z.string(),
    project_id: zod_1.z.string(),
    private_key_id: zod_1.z.string(),
    private_key: zod_1.z.string(),
    client_email: zod_1.z.string(),
    client_id: zod_1.z.string(),
    auth_uri: zod_1.z.string(),
    token_uri: zod_1.z.string(),
    auth_provider_x509_cert_url: zod_1.z.string(),
    client_x509_cert_url: zod_1.z.string(),
});
function assertUniqueKeysAndValues(objects) {
    const seenKeys = new Set();
    const seenValues = new Set();
    for (const object of objects) {
        for (const key of Object.keys(object)) {
            const value = object[key];
            if (seenKeys.has(key) || seenValues.has(value)) {
                throw new AssertionError("These objects should not share the same keys or values!");
            }
            seenKeys.add(key);
            seenValues.add(value);
        }
    }
}
exports.ARRAY_DELIMITER = "; ";
exports.REFER_A_FRIEND_URL = "https://www.orum.com/info/customer-referral-program";
var CustomHTTPHeader;
(function (CustomHTTPHeader) {
    // This is generated via Datadog (with a nanoid fallback) and is used to
    // uniquely identify each request as it is processed by the pipeline.
    CustomHTTPHeader["ORUM_TRACE_ID"] = "x-orum-trace-id";
    // This is a monotonically increasing UTC timestamp that is used to determine
    // whether a client-side bundle needs to be refreshed. It is sent from orum
    // and SAPI and consumed by react-orum.
    CustomHTTPHeader["ORUM_BUNDLE_VERSION"] = "x-orum-bundle";
    // This is the .releaseversion used to build the bundle, and allows us to
    // monitor the uptick rate of new client bundles. It is sent from react-orum
    // and consumed by SAPI.
    CustomHTTPHeader["ORUM_RELEASE_VERSION"] = "x-orum-release";
})(CustomHTTPHeader || (exports.CustomHTTPHeader = CustomHTTPHeader = {}));
// This is a special column added into the table when the user is loading the
// Missed callbacks smart list.
exports.CALLBACK_RECEIVED_COLUMN_NAME = "orum_custom.callbackReceived";
exports.TABLE_DEFAULT_COLUMN_NAMES = [
    "prospectID",
    "entryIDs",
    "state",
    exports.CALLBACK_RECEIVED_COLUMN_NAME,
    "name",
    "phones",
    "links",
];
exports.TABLE_NON_DEFAULT_COLUMN_LIMIT = 20;
exports.TABLE_COLUMN_LIMIT = exports.TABLE_DEFAULT_COLUMN_NAMES.length + exports.TABLE_NON_DEFAULT_COLUMN_LIMIT;
// https://docs.datadoghq.com/ja/tracing/trace_collection/trace_context_propagation/?tab=nodejs#datadog-format
exports.DATADOG_TRACE_HEADER = "x-datadog-trace-id";
exports.DATADOG_TRACE_PARENT_HEADER = "x-datadog-parent-id";
exports.DATADOG_TRACE_ORIGIN_HEADER = "x-datadog-origin";
exports.DATADOG_TRACE_SAMPLING_PRIORITY_HEADER = "x-datadog-sampling-priority";
exports.DATADOG_TRACE_TAGS_HEADER = "x-datadog-tags";
// We impose a 2-hour call duration limit in order to prevent connected but
// inactive calls from persisting forever, while also attempting to avoid
// cutting off real conversations. We heard some rare complaints of calls being
// dropped when the limit was set to 1 hour.
exports.MAX_CONNECT_DURATION_MS = 2 * time_1.HOUR;
exports.AI_NOTES_SEPARATOR = "----- AI Generated Notes -----";
var OrumPage;
(function (OrumPage) {
    OrumPage["STATUS"] = "https://status.orum.com";
    OrumPage["SUPPORT"] = "https://support.orum.com";
    OrumPage["DEMO_REQUEST"] = "https://www.orum.com/request-demo";
})(OrumPage || (exports.OrumPage = OrumPage = {}));
//# sourceMappingURL=constants.js.map